import { render, staticRenderFns } from "./PainterWorks.vue?vue&type=template&id=36480291&scoped=true"
import script from "./PainterWorks.vue?vue&type=script&lang=js"
export * from "./PainterWorks.vue?vue&type=script&lang=js"
import style0 from "./PainterWorks.vue?vue&type=style&index=0&id=36480291&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36480291",
  null
  
)

export default component.exports